import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Result } from '@hereisyourgitanton/core';
import { Observable } from 'rxjs';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';
import { CurrentOrganizationOfferResponseDto } from '../schemas/current-organization-offer-response.dto';

@Injectable({ providedIn: 'root' })
export class OfferApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/offer`;

    getByLotId(lotId: number): Observable<Result<CurrentOrganizationOfferResponseDto, Error>> {
        return this.builder
            .url(`${this.controllerUrl}/getByLotId`)
            .get()
            .json<CurrentOrganizationOfferResponseDto>()
            .withHttpParams(new HttpParams().set('lotId', lotId))
            .build()
            .send();
    }

    getAll(id: number): Observable<Result<CurrentOrganizationOfferResponseDto[], Error>> {
        return this.builder
            .url(`${this.controllerUrl}/GetAll`)
            .get()
            .json<CurrentOrganizationOfferResponseDto[]>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', id))
            .build()
            .send();
    }
}
